import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import {
  Flex,
  Grid,
  GridItem,
} from "@chakra-ui/react";

import { SiteConfig_siteConfig_chpConf } from "graphql/generated";
import { useLiveMeasurements } from "scenes/site/hooks";

import IframeChart from "components/iframe-chart";
import CHPUnitPreview from "./CHPUnitPreview";


interface IProps {
  siteId: string;
  chpConf: SiteConfig_siteConfig_chpConf;
}


const CHP: FunctionComponent<IProps> = ({ siteId, chpConf }) => {
  const intl = useIntl();
  const { data } = useLiveMeasurements(siteId, "chp");

  return (
    <Flex direction="column" justifyContent="space-between" grow={1}>
      <Grid
        templateColumns={`repeat(${chpConf.chps.length}, 1fr)`}
        templateRows={`repeat(${1}, 1fr)`}
        gap={8}
        mb={8}
      >
        {chpConf.chps.map((chp) => {
          const chpData = data[`chp_${chp.id}`];

          return (
            <GridItem key={chp.id}>
              <CHPUnitPreview
                config={chp}
                data={chpData}
                siteId={siteId}
                chpId={+chp.id}
                uiVersion={chpConf.uiVersion}
              />
            </GridItem>
          );
        })}
      </Grid>
      <Flex>
        <IframeChart
          title={intl.formatMessage({
            id: "chp__chart__active_power",
            defaultMessage: "CHP active power chart",
          })}
          chart={chpConf.chartA}
          mr={8}
          mb={0}
        />
        <IframeChart
          title={intl.formatMessage({
            id: "chp__chart__tank_temperature",
            defaultMessage: "CHP temperatures chart",
          })}
          chart={chpConf.chartB}
          mb={0}
        />
      </Flex>
    </Flex>
  );
};

export default CHP;
